@if (headerComponent) {
  <dotcom-frontend-loader [componentData]="headerComponent" />
}

<main class="main-content">
  @if (pageComponent) {
    <dotcom-frontend-loader [componentData]="pageComponent" />
    @if (preFooterContent) {
      <div class="lg-container">
        @for (item of preFooterContent; let i = $index; track i) {
          <dotcom-frontend-loader [componentData]="item" />
        }
      </div>
    }
  }
</main>

@if (footerComponent) {
  <footer>
    <dotcom-frontend-loader [componentData]="footerComponent" />
  </footer>
}

@if (footerCode) {
  @for (item of footerCode; let i = $index; track i) {
    <dotcom-frontend-loader [componentData]="item" parent="footerCode" />
  }
}
